import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { getBillEffectiveStatus } from "@common/helpers/accrual-source";
import { BillLineItem, BillStatus } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import classNames from "classnames";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { BillStatus as BillStatusComponent } from "../../../BillStatus";
import { BillLineItemsViewCallbacks } from "../types";
import styles from "./StatusCell.module.scss";

export const StatusCell = memo(
    ({
        row,
        table,
        getValue,
    }: CellContext<ViewTableFeatures, BillLineItem, BillStatus | null>) => {
        const lineItem = row.original;
        const status =
            getValue() ??
            (lineItem.bill ? getBillEffectiveStatus(lineItem.bill) : null);
        const { callbacks } = useViewTableMeta<
            BillLineItemsViewCallbacks,
            unknown
        >(table);
        const { hasTopSibling, hasBottomSibling } = callbacks?.checkSiblings(
            lineItem,
        ) ?? {
            hasTopSibling: false,
            hasBottomSibling: false,
        };

        return (
            <ViewTableCell>
                <div className={styles.statusContent}>
                    <div
                        className={classNames(styles.statusContentContainer, {
                            [styles.statusContentContainerAdjacentSibling]:
                                hasBottomSibling,
                            [styles.statusContentContainerWithTopLine]:
                                hasTopSibling,
                        })}
                    ></div>
                    {status ? <BillStatusComponent status={status} /> : null}
                </div>
            </ViewTableCell>
        );
    },
);
